module.exports = __webpack_public_path__ + "static/media/Shoes.09323180.png";